import type { CustomField } from "@repo/app-types/entities/customField";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import type { FC, ReactNode } from "react";
import { CustomFieldValue } from "./customFieldValue.js";

export interface UserCustomFieldsSectionProps {
  label: ReactNode;
  customFields: readonly CustomField[];
}

export const UserCustomFieldsSection: FC<UserCustomFieldsSectionProps> = (
  props,
) => {
  const { customFields } = props;

  // Don't render anything if there are no user custom fields
  if (!customFields?.length) {
    return null;
  }

  return (
    <>
      <Label size={Size.MEDIUM} className="mt-4 mb-2">
        {props.label}
      </Label>
      <div className="mt-2 overflow-hidden border border-border-light sm:rounded-lg">
        <table className="min-h-full w-full table-fixed divide-y divide-border-light">
          <thead className="group bg-gray-50">
            <tr>
              <th
                scope="col"
                className="w-[40%] px-4 py-2 text-left text-xs font-medium text-muted-foreground"
              >
                Name
              </th>
              <th
                scope="col"
                className="w-[60%] px-4 py-2 text-left text-xs font-medium text-muted-foreground"
              >
                Value
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border-light bg-white">
            {customFields.map((field) => (
              <tr key={field.field_name} className="group relative">
                <td className="px-4 py-2 text-sm text-foreground">
                  {field.display_name}
                </td>
                <td className="px-4 py-2 text-sm text-foreground">
                  <CustomFieldValue field={field} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
